var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.713,
    height: 91.983,
    viewBox: "0 0 81.713 91.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewGroupe0",
    transform: "translate(-10 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewGroup3-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M339.665,251.536h-14.6a4.514,4.514,0,0,0-4.507,4.507v14.6H280.3c-.051,0-.1-.064-.1-.153v-34h38.929A5.886,5.886,0,0,0,325,230.611V208.317a5.886,5.886,0,0,0-5.878-5.878H280.2V187.507c0-.09.051-.153.1-.153h59.265c.051,0,.1.064.1.153v64.029Zm-14.752,16.02V256.031a.165.165,0,0,1,.154-.154h11.525l-11.679,11.679Zm-56.742-35.408a1.544,1.544,0,0,1-1.524-1.524V208.317a1.544,1.544,0,0,1,1.524-1.524h50.954a1.547,1.547,0,0,1,1.524,1.537v22.295a1.544,1.544,0,0,1-1.524,1.524Zm75.848-44.641A4.487,4.487,0,0,0,339.563,183H280.3a4.487,4.487,0,0,0-4.456,4.507v14.932h-7.658a5.886,5.886,0,0,0-5.878,5.878v22.295a5.886,5.886,0,0,0,5.878,5.878h7.658v33.986a4.487,4.487,0,0,0,4.456,4.508h42.438a1.243,1.243,0,0,0,.218-.013c.039,0,.09-.013.128-.013s.051-.013.09-.013l.154-.039c.013,0,.038-.013.051-.013.051-.013.1-.039.154-.051.013,0,.026-.013.051-.013.051-.026.09-.038.141-.064.013-.013.039-.013.051-.026.039-.026.09-.051.128-.077.013-.013.039-.026.051-.039.038-.026.077-.064.115-.089.013-.013.039-.026.051-.039.051-.051.1-.089.154-.141l19.106-19.106a1.533,1.533,0,0,0,.141-.153c.026-.026.039-.051.064-.077a.4.4,0,0,0,.064-.09c.025-.026.039-.064.064-.09a.557.557,0,0,0,.051-.089c.013-.038.039-.064.051-.1s.026-.064.038-.09.025-.064.039-.1.025-.064.039-.1.013-.064.025-.1.013-.077.026-.1a.357.357,0,0,0,.013-.115c0-.026.013-.064.013-.09a1.246,1.246,0,0,0,.013-.217V187.507Z",
    transform: "translate(-262.306 -183)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(10.734 32.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M322.074,290.908h4.089a10.843,10.843,0,0,1,2.367.2,2.19,2.19,0,0,1,1.274.716,2.253,2.253,0,0,1,.4,1.423v1.934a2.538,2.538,0,0,1-.432,1.573,2.385,2.385,0,0,1-1.368.8,10.742,10.742,0,0,1-2.524.236h-1.352v3.318h-2.453Zm4.01,5.205a2.887,2.887,0,0,0,1.352-.228.826.826,0,0,0,.393-.779v-1.635a.64.64,0,0,0-.377-.66,4.081,4.081,0,0,0-1.4-.157h-1.525v3.46Z",
    transform: "translate(-322.074 -290.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M355.305,290.908h4.34a11.535,11.535,0,0,1,2.831.275,2.627,2.627,0,0,1,1.525.952,3.152,3.152,0,0,1,.487,1.871v4.152a3.057,3.057,0,0,1-.456,1.8,2.5,2.5,0,0,1-1.494.9,12.448,12.448,0,0,1-2.878.259h-4.356Zm4.246,8.461a9.838,9.838,0,0,0,1.517-.086,1.251,1.251,0,0,0,.739-.338,1.147,1.147,0,0,0,.228-.786v-4.2a1.042,1.042,0,0,0-.574-1.015,4.292,4.292,0,0,0-1.832-.291h-1.871v6.715Z",
    transform: "translate(-345.445 -290.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M392.935,290.908h7.941v1.745h-5.488v2.5h4.969V296.9h-4.969v4.215h-2.453Z",
    transform: "translate(-371.909 -290.908)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9af8d5eea1b6819c17c9c93d120900e9.svg";
export { ForwardRef as ReactComponent };